export default __webpack_public_path__ + "static/media/loader.86c721f1.svg";